/**
 * util to return the quarter of the year
 *
 * @param date
 */
export function getQuarterFromDate(date) {
    const month = date.getMonth();
    return Math.floor(month / 3 + 1);
}
